var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6812 9.5999C31.6812 9.5999 31.3688 7.39365 30.4062 6.4249C29.1875 5.1499 27.825 5.14365 27.2 5.06865C22.725 4.74365 16.0063 4.74365 16.0063 4.74365H15.9937C15.9937 4.74365 9.275 4.74365 4.8 5.06865C4.175 5.14365 2.8125 5.1499 1.59375 6.4249C0.63125 7.39365 0.325 9.5999 0.325 9.5999C0.325 9.5999 0 12.1937 0 14.7812V17.2062C0 19.7937 0.31875 22.3874 0.31875 22.3874C0.31875 22.3874 0.63125 24.5937 1.5875 25.5624C2.80625 26.8374 4.40625 26.7937 5.11875 26.9312C7.68125 27.1749 16 27.2499 16 27.2499C16 27.2499 22.725 27.2374 27.2 26.9187C27.825 26.8437 29.1875 26.8374 30.4062 25.5624C31.3688 24.5937 31.6812 22.3874 31.6812 22.3874C31.6812 22.3874 32 19.7999 32 17.2062V14.7812C32 12.1937 31.6812 9.5999 31.6812 9.5999ZM12.6938 20.1499V11.1562L21.3375 15.6687L12.6938 20.1499Z",
    fill: "#03122E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.1b7028a9c5cdfefb601ba9e76b3aede2.svg";
export { ForwardRef as ReactComponent };